import { autoinject, computedFrom } from "aurelia-framework";
import { Location } from "../../models/location";
import * as Linq from "linq-es2015";
import { dispatchify, Store } from "aurelia-store";
import { getLocationWarnings } from "../../store/actions/measurement-actions";
import * as State from "../../store/state";
import IState = State.IState;
import { Subscription } from "rxjs";
import { MeasurementViewModel } from "../../models/measurement-view-model";
import { MdTabs } from "aurelia-materialize-bridge";

@autoinject
export class WarningTableau {
	locations: Array<Location> = new Array<Location>();
	selectedLocation: Location;
	hasLocations: boolean = false;
	isActive: boolean = false;
	tabs: MdTabs;
	protected applicationState: IState;
	protected subscription: Subscription;
	protected store: Store<IState>;

	constructor(store: Store<IState>) {
		this.store = store;
	}

	bind(bindingContext: any, overrideContext: any) {

		this.subscription = this.store.state.subscribe(async (state) => {

			this.applicationState = state;
			if (this.applicationState.locationState.initialized) {
				this.locations = this.applicationState.locationState.selectedLocations;
				if (!this.selectedLocation && this.locations && this.locations.length > 0) {
					this.selectedLocation = this.getCurrentLocation();
					//this.tabs.select(this.selectedLocation.id);
					await this.getWarnings(this.selectedLocation.id);
					this.hasLocations = true;
					this.tabs.refresh();
				}
			}
		});


	}

	attached(args: any) {
		// wait 100 ms to allow the MdTabs attached method to fire and thus create an instance of the underlying tab control
		// otherwise the call to tabs.select will fail.
		setTimeout(() => {
			if (this.locations && this.locations.length > 0 &&
				this.selectedLocation &&
				this.selectedLocation.id !== this.locations[0].id) {
				this.tabs.select(this.selectedLocation.id);
			}
		}, 100);
	}

	getCurrentLocation() : Location {
		const currentLocationId = localStorage.getItem("current-location");
		if (!currentLocationId) {
			return this.locations[0];
		}

		const currentLocations = this.locations.filter(l => l.id === currentLocationId);
		return currentLocations[0];
	}

	//getSelectedScale() {
	//	let scale = localStorage.getItem("temperature-scale");
	//	if (!scale) {
	//		scale = TemperatureScales.fahrenheit;
	//	}
	//	return this.getScale(scale);
	//}

	async activate() {
		await this.getWarnings(this.selectedLocation.id);
		this.tabs.refresh();
	}

	unbind() {
		this.subscription.unsubscribe();
	}

	@computedFrom("selectedLocation")
	get warnings(): Array<MeasurementViewModel> {
		return this.selectedLocation.currentMeasurements.filter(measurement => measurement.metadata && measurement.metadata.deviceType !== "UrsalinkUc1114");
	}

	@computedFrom("locations")
	get locationsLoaded() {
		return this.locations.length > 0;
	}

	@computedFrom("applicationState")
	get hasWarnings(): boolean {
		return this.selectedLocation ? (this.selectedLocation.currentMeasurements ? this.selectedLocation.currentMeasurements.length > 0 : false) : false;
	}

	async getWarnings(locationId: string) {
		this.isActive = true;
		await dispatchify(getLocationWarnings)(locationId);
		this.isActive = false;
	}

	async refreshWarnings() {
		await this.getWarnings(this.selectedLocation.id);
	}

	async onTabSelected($event) {
		const locationId = $event.detail.substring(1);
		const locationList = Linq.AsEnumerable(this.locations);
		this.selectedLocation = locationList.First(location => location.id === locationId);
		localStorage.setItem("current-location", this.selectedLocation.id);
		await this.getWarnings(this.selectedLocation.id);
	}
}
